import { MsalProvider } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { RouterProvider } from 'react-router-dom';

import { getMsalInstance } from './auth/msal.js';
import { LOCAL_MODE } from './config/local-mode.js';
import { router } from './router.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

export function App(): JSX.Element {
  const tree = (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
  // Phase 14: skip the MSAL provider entirely in local mode. Anything that
  // calls `useMsal()` is gated by `useToken`/`AuthGate` and short-circuits
  // before reaching the MSAL hooks.
  return LOCAL_MODE ? tree : wrapWithMsal(tree);
}

function wrapWithMsal(children: ReactNode): JSX.Element {
  return <MsalProvider instance={getMsalInstance()}>{children}</MsalProvider>;
}
